import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import '@/index.css';

import Navigation from '@/components/layout/Navigation';
import Footer from '@/components/layout/Footer';

import Home from '@/pages/Home';
import Work from '@/pages/Work';
import Industries from '@/pages/Industries';
import Services from '@/pages/Services';
import Process from '@/pages/Process';
import About from '@/pages/About';
import Contact from '@/pages/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-background text-foreground grain">
      <Navigation />
      <AnimatePresence mode="wait">
        <Routes location={{ pathname }} key={pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/services" element={<Services />} />
          <Route path="/process" element={<Process />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </AnimatePresence>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      if (e.matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };
    
    // Initial check
    handleChange(mediaQuery);
    
    // Listen for OS theme changes
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>TechsFlow | Clinic Website Design Studio</title>
        <meta name="description" content="TechsFlow is a frontend-first studio that designs and builds unhurried, considered websites for dermatologists, dental, and aesthetic clinics." />
      </Helmet>
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
      </BrowserRouter>
    </HelmetProvider>
  );
}
